// extracted by mini-css-extract-plugin
export var content = "_nl-1";
export var fullScreen = "_nl-0";